module.exports = __webpack_public_path__ + "img/maintenance-4.6798cdeb.gif";